export const lightPaletteText = {
  primary: 'rgb(17, 24, 39)',
  secondary: 'rgb(107, 114, 128)',
  disabled: 'rgb(149, 156, 169)',
};

export const darkPaletteText = {
  primary: 'rgb(148, 163, 184)',
  secondary: 'rgba(0,0,0,0.87)',
  disabled: 'rgb(156, 163, 175)',
};
export const fontFamily = [
  'dana',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
];
const themesConfig = {
  default: {
    palette: {
      mode: 'light',
      divider: '#e2e8f0',
      text: lightPaletteText,
      common: {
        black: 'rgb(17, 24, 39)',
        white: 'rgb(255, 255, 255)',
      },
      // divider: "rgba(36,36,36,0.5)",
      primary: {
        main: '#57C4D0',
        light: '#B8EBEE',
        dark: '#408086',
        100: '#F6FCFD',
        200: '#E2F6F8',
        300: '#B8EBEE',
        500: '#57C4D0',
        700: '#4CAAB6',
        900: '#408086',
        contrastText: '#fff',
      },
      secondary: {
        light: '#FEF597',
        main: '#FFDD1C',
        dark: '#FE7F00',
        100: '#FFFCDB',
        200: '#FFFCDB',
        300: '#FEF597',
        500: '#FFDD1C',
        700: '#FFAC00',
        900: '#FE7F00',
        contrastText: 'rgba(0, 0, 0, 0.87)',
      },
      error: {
        main: '#E60000',
        light: '#FFF1F4',
        contrastText: '#fff',
      },
      success: {
        main: '#05C100',
        light: '#EDFFEC',
      },
      warning: {
        main: '#FE7F00',
      },

      info: {
        main: '#4CAAB6',
      },

      gray: {
        default: '#FEFEFE',
        paper: '#f3f3f3',
        400: '#D1D1D1',
        600: '#A2A2A2',
        800: '#666666',
        900: '#252525',
      },
      background: {
        paper: '#FEFEFE',
        default: '#f3f3f3',
      },
    },
    status: {
      danger: 'orange',
    },

    shadows: [
      'none',
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);',
      '0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16)',
      '0px 0px 2px rgba(40, 41, 61, 0.04), 0px 4px 8px rgba(96, 97, 112, 0.16)',
      '0px 64px 64px -32px #6625008F',
      '0px 2px 8px rgba(40, 41, 61, 0.04), 0px 16px 24px rgba(96, 97, 112, 0.16)',
      ...new Array(19).fill(
        '0px 2px 8px rgba(40, 41, 61, 0.08), 0px 20px 32px rgba(96, 97, 112, 0.24)'
      ),
    ],
    typography: {
      fontFamily: fontFamily.join(','),
      fontWeightLight: 100,
      fontWeightRegular: 400,
      h1: {
        fontSize: 40,
        lineHeight: 3.375,
        fontWeight: 800,
      },
      h2: {
        fontSize: 32,
        lineHeight: 2.75,
        fontWeight: 800,
      },
      h3: {
        fontSize: 28,
        lineHeight: 2.375,
        fontWeight: 800,
      },
      h4: {
        fontSize: 24,
        lineHeight: 2,
        fontWeight: 800,
      },
      h5: {
        fontSize: 20,
        lineHeight: 1.75,
        fontWeight: 800,
      },
      h6: {
        fontSize: 16,
        lineHeight: 1.375,
        fontWeight: 800,
      },
      body1: {
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: 400,
      },
      body2: {
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: 400,
      },
      subtitle1: {
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: 600,
      },
      subtitle2: {
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: 600,
      },
      caption: {
        fontSize: 12,
        lineHeight: 1.125,
        fontWeight: 400,
      },
      button: {
        fontSize: 14,
        lineHeight: 1.75,
        fontWeight: 400,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          '*': {
            fontFamily: fontFamily.join(','),
          },
          'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          'input[type=number]': {
            MozAppearance: 'textfield',
          },
          '.space-between-letters input': {
            letterSpacing: '5px !important',
          },
          '.PrivateDatePickerToolbar-penIcon, .MuiPickersToolbar-penIconButton': {
            display: 'none !important',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: (theme) => ({
            color: '#697180',
            '&, & *': {
              transition: 'all 0.2s cubic-bezier(.4,0,.2,1)',
            },
            backgroundColor: theme.palette.background.paper,
            '&.Mui-disabled': {
              backgroundColor: 'rgba(152,163,184, 0.1)',
              color: 'rgba(135,147,165, 0.4)',
            },
            '&.Mui-focused': {
              '&.Mui-error': {
                backgroundColor: '#fe434310',
              },
              backgroundColor: '#3E7BFA10',
            },
            // '&.Mui-disabled .MuiOutlinedInput-notchedOutline, &:not(.Mui-focused):not(.Mui-error):hover .MuiOutlinedInput-notchedOutline':
            //   {
            //     borderColor: 'transparent',
            //   },
          }),
          input: {
            padding: 16,
          },
          // notchedOutline: {
          //   borderColor: 'transparent',
          // },
        },
      },
      MuiSkeleton: {
        defaultProps: {
          animation: 'wave',
        },
      },
      MuiButton: {
        styleOverrides: {
          sizeSmall: {
            paddingTop: 5,
            paddingBottom: 2,
          },
          sizeMedium: {
            paddingTop: 10,
            paddingBottom: 7,
          },
          sizeLarge: {
            paddingTop: 12,
            paddingBottom: 8,
          },
          outlinedSizeSmall: {
            paddingTop: 6,
            paddingBottom: 4,
          },
          outlinedSizeMedium: {
            paddingTop: 8,
            paddingBottom: 5,
          },
          outlinedSizeLarge: {
            paddingTop: 13,
            paddingBottom: 10,
          },
          iconSizeLarge: {
            marginBottom: 3,
          },
          iconSizeMedium: {
            marginBottom: 2,
          },
          iconSizeSmall: {
            marginBottom: 1,
          },
          root: {
            borderRadius: '10px !important',
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          sizeSmall: {
            minHeight: 37,
          },
        },
      },
    },
  },
  defaultDark: {
    palette: {
      mode: 'dark',
      divider: 'rgba(241,245,249,.12)',
      text: darkPaletteText,
      common: {
        black: 'rgb(17, 24, 39)',
        white: 'rgb(255, 255, 255)',
      },
      primary: {
        light: '#64748b',
        main: '#334155',
        dark: '#0f172a',
        contrastText: darkPaletteText.primary,
      },
      secondary: {
        light: '#818cf8',
        main: '#4f46e5',
        dark: '#3730a3',
        contrastText: darkPaletteText.primary,
      },
      background: {
        paper: '#1e293b',
        default: '#111827',
      },
      error: {
        light: '#ffcdd2',
        main: '#f44336',
        dark: '#b71c1c',
      },
      status: {
        danger: 'orange',
      },
    },
  },
  navTheme: {
    palette: {
      mode: 'dark',
      divider: 'rgba(241,245,249,.12)',
      text: darkPaletteText,
      common: {
        black: 'rgb(17, 24, 39)',
        white: 'rgb(255, 255, 255)',
      },
      primary: {
        light: '#64748b',
        main: '#fff',
        dark: '#3A1919',
        contrastText: darkPaletteText.primary,
      },
      secondary: {
        light: '#818cf8',
        main: '#4f46e5',
        dark: '#3730a3',
        contrastText: darkPaletteText.primary,
      },
      background: {
        paper: '#1e293b',
        default: '#fff',
      },
      error: {
        light: '#ffcdd2',
        main: '#f44336',
        dark: '#b71c1c',
      },
      status: {
        danger: 'orange',
      },
    },
  },
};

export default themesConfig;
